module.exports = __webpack_public_path__ + "img/ico-search.f32d2aab.svg";